import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import Popup from "../ui/Popup";

import { lightBodyStyle, buttonLightStyle, darkBodyStyle } from "../styles";

import { saveThemeCookie } from "../lib/manageCookies";

interface LoginProps extends Omit<PageProps, "setContent" | "setModalOpen"> {
  setDark: SetBoolean;
  username: string;
  setUsername: React.Dispatch<React.SetStateAction<string>>;
  setAuth: SetBoolean;
  setIsQuizCompleted: SetBoolean;
}

export default function Login({
  isMobile,
  isVertical,
  isDark,
  setDark,
  username,
  setUsername,
  setAuth,
  setIsQuizCompleted,
}: LoginProps) {
  const [password, setPassword] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    const response = await fetch("https://yda-wedding.fun/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username: username, password: password }),
      credentials: "include",
    });

    if (response.ok) {
      const data = await response.json();
      console.log(data);
      setIsQuizCompleted(data["is_quiz_completed"]);

      setAuth(true);
      navigate("/main");
    } else {
      setPopupOpen(true);
    }
  };

  return (
    <div
      className={`flex flex-col w-full h-screen gap-12 items-center justify-center 
      ${isDark ? darkBodyStyle : lightBodyStyle}`}
    >
      <form
        className={`flex flex-col w-84 justify-between gap-12
          p-12 rounded-xl items-center ${
            isMobile && !isVertical ? "mt-10" : ""
          } 
          ${isDark ? "bg-gray-900" : "bg-red-100"}`}
        onSubmit={handleSubmit}
      >
        <h1 className="text-center text-xl">Необходима авторизация</h1>
        <div className="flex gap-8">
          <div className="flex flex-col gap-4">
            <input
              className={`outline-none rounded-lg text-center ${
                isDark ? "bg-gray-700" : "bg-white"
              }`}
              placeholder="Имя пользователя"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
            />
            <input
              className={`outline-none rounded-lg text-center ${
                isDark ? "bg-gray-700" : "bg-white"
              }`}
              placeholder="Пароль"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-12">
          <button
            className={`${buttonLightStyle} ${
              isDark ? "bg-gray-800" : "bg-white"
            }
            `}
            type="submit"
          >
            Войти
          </button>
          <button
            onClick={() => {
              saveThemeCookie(!isDark);
              setDark(!isDark);
            }}
            type="button"
          >
            <img
              src={
                isDark ? "/header/theme-dark.png" : "/header/theme-light.png"
              }
              alt="theme"
              width={30}
            />
          </button>
        </div>
      </form>
      <div className="h-8">
        <Popup
          isDark={isDark}
          isOpen={isPopupOpen}
          setOpen={setPopupOpen}
          content={<p>Ошибка авторизации. Неверный логин или пароль</p>}
        />
      </div>
    </div>
  );
}
